module.exports = __webpack_public_path__ + "img/loading.35868999.png";